"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = convertSrtToVtt;

function convertSrtCue(caption) {
  // remove all html tags for security reasons
  // srt = srt.replace(/<[a-zA-Z\/][^>]*>/g, '');
  var cue = '';
  var s = caption.split(/\n/); // concatenate muilt-line string separated in array into one

  while (s.length > 3) {
    for (var i = 3; i < s.length; i += 1) {
      s[2] += "\n".concat(s[i]);
    }

    s.splice(3, s.length - 3);
  }

  var line = 0; // detect identifier

  if (!s[0].match(/\d+:\d+:\d+/) && s[1].match(/\d+:\d+:\d+/)) {
    // $FlowFixMe
    cue += "".concat(s[0].match(/\w+/), "\n");
    line += 1;
  } // get time strings


  if (s[line].match(/\d+:\d+:\d+/)) {
    // convert time string
    var m = s[1].match(/(\d+):(\d+):(\d+)(?:,(\d+))?\s*--?>\s*(\d+):(\d+):(\d+)(?:,(\d+))?/);

    if (m) {
      cue += "".concat(m[1], ":").concat(m[2], ":").concat(m[3], ".").concat(m[4], " --> ").concat(m[5], ":").concat(m[6], ":").concat(m[7], ".").concat(m[8], "\n");
      line += 1;
    } else {
      // Unrecognized timestring
      return '';
    }
  } else {
    // file format error or comment lines
    return '';
  } // get cue text


  if (s[line]) {
    cue += "".concat(s[line], "\n\n");
  }

  return cue;
}

function convertSrtToVtt(data) {
  try {
    // remove dos newlines
    var srt = data.replace(/\r+/g, ''); // trim white space start and end

    srt = srt.replace(/^\s+|\s+$/g, ''); // get cues

    var cuelist = srt.split('\n\n');
    var result = '';

    if (cuelist.length > 0) {
      result += 'WEBVTT\n\n';

      for (var i = 0; i < cuelist.length; i += 1) {
        result += convertSrtCue(cuelist[i]);
      }
    }

    if (result.match(/^\s*WEBVTT\s*$/)) {
      throw new Error('NO VALID SRT DATA FOUND');
    }

    return result;
  } catch (err) {
    console.error('SRT CONVERSION ERROR');
    return null;
  }
}